import { __decorate } from "tslib";
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, concat, defer, ignoreElements, map, of } from 'rxjs';
import _ from 'lodash';
import { SailsSocketService } from '../../modules/sails-socket';
let ResourceService = class ResourceService {
    sails = inject(SailsSocketService);
    _model = { byId: {}, byResourceList: {} };
    get model() {
        return this._model;
    }
    getResources(resourceListId) {
        return this.createObservable(`/resourcelist/${resourceListId}/resources`)
            .pipe(map(({ data }) => {
            this._model.byResourceList[resourceListId] = [];
            this.updateModel(data.resources);
            return this.model;
        }));
    }
    getResourcesForResourceList(resourceListId) {
        const byResourceList$ = defer(() => of(this._model.byResourceList[resourceListId] || []));
        const retrieveResources$ = _.isEmpty(this._model.byResourceList[resourceListId])
            ? this.getResources(resourceListId)
            : EMPTY;
        return concat(retrieveResources$.pipe(ignoreElements()), byResourceList$);
    }
    updateModel(data) {
        _.forEach(data, (resource) => {
            this._model.byId[resource.id] = resource;
            const resourceListId = resource.resourcelist;
            this._model.byResourceList[resourceListId] = this._model.byResourceList[resourceListId] || [];
            this._model.byResourceList[resourceListId].push(resource);
        });
    }
    createObservable(url, method = 'get', data) {
        return new Observable((subscriber) => {
            const subscription = this.sails[method](url, data).subscribe({
                next: (response) => {
                    subscriber.next(response);
                    subscriber.complete();
                },
                error: (error) => subscriber.error(error),
            });
            return () => subscription.unsubscribe();
        });
    }
};
ResourceService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ResourceService);
export { ResourceService };
